var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 20H4M44 22V16.4C44 14.1598 44 13.0397 43.564 12.184C43.1805 11.4314 42.5686 10.8195 41.816 10.436C40.9603 10 39.8402 10 37.6 10H10.4C8.15979 10 7.03969 10 6.18404 10.436C5.43139 10.8195 4.81947 11.4314 4.43597 12.184C4 13.0397 4 14.1598 4 16.4V31.6C4 33.8402 4 34.9603 4.43597 35.816C4.81947 36.5686 5.43139 37.1805 6.18404 37.564C7.03969 38 8.15979 38 10.4 38H23M36 42C36 42 42 39.1402 42 34.8505V29.8458L37.6248 28.2824C36.5736 27.9059 35.424 27.9059 34.3728 28.2824L30 29.8458V34.8505C30 39.1402 36 42 36 42Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/b4.22c015980831a69992cf27b39f1b0072.svg";
export { ForwardRef as ReactComponent };